/**
 * BreadcrumbSchema — emits a JSON-LD <script> with schema.org BreadcrumbList
 * for the current page. Pure SEO output — renders nothing visible.
 *
 * Implementation:
 *   The JSON is rendered as React text children of the <script> tag
 *   (NOT via dangerouslySetInnerHTML), so React handles all escaping
 *   automatically. Browsers do not execute `type="application/ld+json"`
 *   blocks as JavaScript — they're consumed only by search-engine crawlers.
 *
 * Usage:
 *   <BreadcrumbSchema items={[
 *     { name: 'Home', url: '/' },
 *     { name: 'Study Abroad', url: '/study-abroad/' },
 *     { name: 'Germany', url: '/study-abroad/germany/' },
 *     { name: 'Student Visa', url: '/study-abroad/germany/student-visa/' },
 *   ]} />
 *
 * The component:
 *  - Auto-prefixes relative `url` values with https://zafco.in
 *  - Sets `position` automatically (1-indexed)
 *  - Omits the trailing item's url field per schema.org recommendation
 *    (the current page is implicit)
 */

const BASE_URL = 'https://zafco.in';

const BreadcrumbSchema = ({ items = [] }) => {
  if (!items.length) return null;

  const itemListElement = items.map((item, idx) => {
    const isLast = idx === items.length - 1;
    const absUrl = item.url?.startsWith('http')
      ? item.url
      : `${BASE_URL}${item.url || ''}`;

    const node = {
      '@type': 'ListItem',
      position: idx + 1,
      name: item.name,
    };
    if (!isLast) node.item = absUrl;
    return node;
  });

  const ldJson = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement,
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(ldJson)}
    </script>
  );
};

export default BreadcrumbSchema;
